import {
	Archive,
	Barcode,
	Building,
	Calendar,
	Categories,
	Contacts,
	Database,
	Depreciation,
	DotsHorizontal,
	Email,
	FlagAlt,
	Kits,
	LinkExternal,
	Marker,
	Number,
	Phone,
	Qr,
	RfidIcon,
	RoundedSquare,
	User,
} from '@cheqroom/icons';

import type { FieldIconResolver } from '../Fields.types';

const getSystemFieldIcon = (id: string) => {
	switch (id) {
		case 'barcodes':
			return Barcode;
		case 'codes':
			return Qr;
		case 'rfidcodes':
			return RfidIcon;
		case 'purchaseDate':
		case 'warrantyDate':
		case 'created':
		case 'modified':
			return Calendar;
		case 'address':
			return Marker;
		case 'location':
			return undefined; // ItemInfo.Location resolves its own location-specific icon
		case 'purchasePrice':
		case 'residualValue':
			return Depreciation;
		case 'flag':
			return FlagAlt;
		case 'contact':
		case 'custody':
			return Contacts;
		case 'category':
			return Categories;
		case 'kit':
			return Kits;
		case 'retired':
			return Archive;
		case 'brand':
		case 'model':
			return RoundedSquare;
		case 'quantity':
			return Number;
		case 'itemTypeId':
			return Database;
		default:
			return DotsHorizontal;
	}
};

/** Icon for a custom field (`fields.*`), based on its `kind`/`editor`. */
const getCustomFieldIcon = (field: Parameters<FieldIconResolver>[0]) => {
	if (field.kind === 'customer') return User;
	if (field.kind === 'location') return Building;

	switch (field.type) {
		case 'date':
		case 'datetime':
			return Calendar;
		case 'url':
			return LinkExternal;
		case 'email':
			return Email;
		case 'phone':
			return Phone;
		case 'currency':
			return Depreciation;
		case 'number':
			return Number;
		default:
			return DotsHorizontal;
	}
};

export const getIconForField: FieldIconResolver = (field) => {
	if (field.icon) return field.icon;

	if (field.id.startsWith('fields.')) return getCustomFieldIcon(field);

	return getSystemFieldIcon(field.id);
};
